import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_SHIPPING_GUIDES_CPE = '[CPE] GET SHIPPING GUIDES CPE'
export const SEND_UNINFORMED_SHIPPING_GUIDES_TO_SUNAT = '[CPE] SEND UNINFORMED SHIPPING GUIDES TO SUNAT'
export const SEND_SHIPPING_GUIDE_TO_SUNAT = '[CPE] SEND SHIPPING GUIDE TO SUNAT'

export function getShippingGuidesCPEAction(filters = { startDate: '', endDate: '', status: '', search: '', pageSize: 10 }) {
  const request = api.get(`/shipping-guides-cpe/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_SHIPPING_GUIDES_CPE, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_SHIPPING_GUIDES_CPE, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_SHIPPING_GUIDES_CPE, error)
    }).finally(() => {
      dispatch({ type: GET_SHIPPING_GUIDES_CPE, payload: { loading: false } })
    })
  }
}

export function sendUninformedShippingGuidesToSunatAction() {
  const request = api.post(`/shipping-guides-cpe/send-uninformed-to-sunat`)
  return (dispatch) => {
    dispatch({ type: SEND_UNINFORMED_SHIPPING_GUIDES_TO_SUNAT, payload: { sending: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      toast.success(response.data.message)
      dispatch({ type: SEND_UNINFORMED_SHIPPING_GUIDES_TO_SUNAT, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(SEND_UNINFORMED_SHIPPING_GUIDES_TO_SUNAT, error)
    }).finally(() => {
      dispatch({ type: SEND_UNINFORMED_SHIPPING_GUIDES_TO_SUNAT, payload: { sending: false } })
    })
  }
}

export function sendShippingGuideToSunatAction(creditNoteId) {
  const request = api.post(`/shipping-guide-cpe/send-to-sunat/${creditNoteId}`)
  return (dispatch) => {
    dispatch({ type: SEND_SHIPPING_GUIDE_TO_SUNAT, payload: { sending_id: creditNoteId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SEND_SHIPPING_GUIDE_TO_SUNAT, payload: { sent_id: creditNoteId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SEND_SHIPPING_GUIDE_TO_SUNAT, error)
    }).finally(() => {
      dispatch({ type: SEND_SHIPPING_GUIDE_TO_SUNAT, payload: { sending_id: creditNoteId } })
    })
  }
}

export function checkIfShippingGuideWasSentToSunatAction(creditNoteId) {
  const request = api.get(`/shipping-guide-cpe/check-sent/${creditNoteId}`)
  request.then((response) => {
    if (Number(response.data.status) !== 200) {
      toast.error(response.data.message)
      return
    }
    toast.success(response.data.message)
  }).catch((error) => {
    console.log(error)
  })
}
